import styles from "./NotFoundPage.module.scss";

const PageNotFound = () => {
  return (
    <div className={styles.wrapper}>
      <h2 className={styles.wrapper_title}>404</h2>
      <p className={styles.wrapper_description}>Page not found</p>
    </div>
  );
};

export default PageNotFound;
